import dayjs from 'dayjs'

export const isValidNullableDate = (value: string) => {
  if (!value) return true

  const year = value.split('-')[0] ?? ''

  if (!year) return false

  const yearOnlyPattern = /^[1|2]\d{3}--$/
  const yearAndMonthPattern = /^[1|2]\d{3}-[a-zA-Z0-9]*-$/
  const filledPattern = /^[1|2]\d{3}-[a-zA-Z0-9]+-[a-zA-Z0-9]*$/

  return (
    !!value.match(yearOnlyPattern) ||
    !!value.match(yearAndMonthPattern) ||
    !!value.match(filledPattern)
  )
}

export const isValidTimeValue = (value: string) => {
  if (value === '') return true

  const matched = value.match(/^([012]?\d):([0-5]?\d$)/)
  if (!matched) return false

  const hourStr = matched[1]
  const minuteStr = matched[2]
  const hour = Number(hourStr)
  const minute = Number(minuteStr)

  return 0 <= hour && hour <= 23 && 0 <= minute && minute <= 59
}

export const isValidDateValue = (value: string) => {
  if (value === '') return true

  const matched = value.match(/^([12]\d{3})-([0-2]?\d)-([0123]?\d)$/)
  if (!matched) return false

  const year = Number(matched[1])
  const month = Number(matched[2])
  const day = Number(matched[3])

  const valueDayJs = dayjs(value, 'YYYY-MM-DD')

  // dayjs は存在しない日付でも valid な日付として parse するので、parse 後の年月日と元の年月日それぞれを比較する
  return (
    year === valueDayJs.year() &&
    // dayjs が返す month は 0~11 なので +1 している
    month === valueDayJs.month() + 1 &&
    day === valueDayJs.date()
  )
}
